/* Tayga 2027 — interacciones de secciones tg-* + motor de relevancia (v1). */
(function () {
  'use strict';
  var LS_KEY = 'tg_rel_v1';
  var TTL = 7 * 24 * 3600 * 1000;

  function store() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch (e) { return {}; }
  }
  function save(d) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(d)); } catch (e) {}
  }
  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
    } catch (e) {}
    return true;
  }

  // 1) Señal de anuncio: ?tg_cat=handle&tg_p=handle (se guarda 7 días)
  var qs = new URLSearchParams(location.search);
  var d = store();
  if (qs.get('tg_cat') || qs.get('tg_p')) {
    d.ad = { cat: qs.get('tg_cat') || null, p: qs.get('tg_p') || null, t: Date.now() };
  }
  if (d.ad && Date.now() - d.ad.t > TTL) delete d.ad;

  // 2) Comportamiento: colecciones vistas (solo con consentimiento de marketing)
  if (marketingAllowed()) {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (m && m[1] !== 'all') {
      d.cats = (d.cats || []).filter(function (c) { return c !== m[1]; });
      d.cats.unshift(m[1]); d.cats = d.cats.slice(0, 10);
    }
    if (/\/pages\/gimnasios/.test(location.pathname)) d.b2b = true;
  }
  save(d);
  window.TG27 = { signals: d };

  // ---------- Marquee selector + más vendidos ----------
  function initBest(root) {
    if (root.__tg) return; root.__tg = true;
    var words = root.querySelectorAll('[data-tg-word]');
    var panels = root.querySelectorAll('[data-tg-panel]');
    var nameEls = root.querySelectorAll('[data-tg-name]');
    var link = root.querySelector('[data-tg-link]');
    var prog = root.querySelector('[data-tg-prog]');
    var rot = parseInt(root.getAttribute('data-rotate') || '5', 10) * 1000;
    var order = [];
    panels.forEach(function (p) { order.push(p.getAttribute('data-tg-panel')); });
    if (!order.length) return;
    var cur = null, auto = true, timer = null;

    var show = function (h) {
      if (order.indexOf(h) < 0) return;
      cur = h;
      panels.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-tg-panel') === h); });
      words.forEach(function (w) { w.classList.toggle('is-on', w.getAttribute('data-tg-word') === h); });
      var p = root.querySelector('[data-tg-panel="' + h + '"]');
      nameEls.forEach(function (n) { n.textContent = p.getAttribute('data-title'); });
      if (link) link.setAttribute('href', p.getAttribute('data-url'));
      if (prog) {
        prog.classList.remove('is-run'); prog.style.width = ''; void prog.offsetWidth;
        if (auto) prog.classList.add('is-run'); else prog.style.width = '100%';
      }
    };
    // Orden inicial por relevancia: anuncio > última colección vista > b2b > primero
    var start = order[0];
    if (d.ad && d.ad.cat && order.indexOf(d.ad.cat) > -1) start = d.ad.cat;
    else if (d.cats && d.cats.some(function (c) { return order.indexOf(c) > -1; })) {
      start = d.cats.filter(function (c) { return order.indexOf(c) > -1; })[0];
    } else if (d.b2b && order.indexOf(root.getAttribute('data-b2b')) > -1) start = root.getAttribute('data-b2b');
    // Producto del anuncio al frente de su panel
    if (d.ad && d.ad.p) {
      var hit = root.querySelector('[data-tg-panel="' + start + '"] [data-handle="' + d.ad.p + '"]');
      if (hit) hit.parentNode.insertBefore(hit, hit.parentNode.firstChild);
    }
    if (d.ad && d.ad.cat) auto = false;
    // Precarga de fotos: las categorías ocultas traen imágenes lazy que no se bajan hasta mostrarse.
    // Cuando el carrusel se acerca a la pantalla se precarga la siguiente categoría y luego el resto.
    var warmed = {}, near = false;
    function warm(h) {
      if (!h || warmed[h]) return; warmed[h] = true;
      var p = root.querySelector('[data-tg-panel="' + h + '"]');
      if (p) p.querySelectorAll('img.tg-card__main').forEach(function (img) { img.loading = 'eager'; });
    }
    function next(h) { return order[(order.indexOf(h) + 1) % order.length]; }
    function warmAll() {
      var i = 0;
      (function step() { if (i >= order.length) return; warm(order[i++]); setTimeout(step, 400); })();
    }
    var show0 = show;
    show = function (h) { show0(h); if (near) warm(next(h)); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect(); near = true; warm(cur); warm(next(cur)); setTimeout(warmAll, 1200);
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else { near = true; warmAll(); }
    show(start);
    timer = setInterval(function () { if (auto) show(order[(order.indexOf(cur) + 1) % order.length]); }, rot);
    words.forEach(function (w) {
      w.addEventListener('click', function () { auto = false; clearInterval(timer); show(w.getAttribute('data-tg-word')); });
    });
  }

  function boot() { document.querySelectorAll('[data-tg-best]').forEach(initBest); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
